import { Component, input, computed } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EvGridTableModule, ITableLayoutModel, ITableHeader, BaseListComponent } from "ev-grid-table";
import { UnitEnergyLabelHistory } from "src/models/energy-estimate/unit-energy-label-history.model";
import { DefaultConverterPipe } from "src/app/shared/pipes/defaultconverter.pipe";
import { EnergyLabelColor, EnergyLabelVersion } from "src/models/common/energy.enums";

@Component({
    selector: "energy-label-history",
    templateUrl: "./energy-label-history.component.html",
    styleUrls: ["./energy-label-history.component.scss"],
    imports: [EvGridTableModule, CommonModule, DefaultConverterPipe],
})
export class EnergyLabelHistoryComponent extends BaseListComponent<UnitEnergyLabelHistory> {
    energyLabelHistory = input.required<UnitEnergyLabelHistory[]>();

    originalData = computed(() => this.energyLabelHistory() || []);

    constructor() {
        super();

        this.numberOfRowsConfig.set({ rowsToShow: this.rowsToShow });
    }

    getEnergyLabelClass(energyLabelLetter: string, energyLabelVersion: EnergyLabelVersion, energyLabelColorId: number): string {
        if (energyLabelVersion == EnergyLabelVersion.Version2026) {
            return "energy-label26 icon-energy26-" + energyLabelLetter.toLowerCase();
        }

        return energyLabelLetter.toLowerCase() + "-" + EnergyLabelColor[energyLabelColorId]?.toLowerCase();
    }

    getEnergyLabelEnovaNumber(unitEnergyLabelHistory: UnitEnergyLabelHistory): string {
        if (unitEnergyLabelHistory?.certificateNumber) {
            return unitEnergyLabelHistory.certificateNumber;
        }

        return unitEnergyLabelHistory?.energyLabelID;
    }

    protected createHeaders(): ITableHeader[] {
        return [
            {
                name: "Dato",
                prop: "issuedDate",
                desc: true,
                type: "date",
                isSortable: true,
            },
            {
                name: "Merke",
                prop: "energyLabelLetter",
                desc: true,
                type: "text",
                isSortable: true,
            },
            {
                name: "Kilde",
                prop: "source",
                desc: true,
                type: "text",
                isSortable: true,
            },
            {
                name: "Metode",
                prop: "method",
                desc: true,
                type: "text",
                isSortable: true,
            },
            {
                name: "Attestnr",
                prop: "energyLabelID",
                desc: true,
                type: "text",
                isSortable: false,
            },
            {
                name: "Bygning",
                prop: "buildingID",
                type: "number",
                desc: true,
                isSortable: true,
            },
            {
                name: "Bruksenhet",
                prop: "functionalUnitNumber",
                type: "text",
                desc: true,
                isSortable: true,
            },
        ];
    }

    protected createDisplayTemplate(): ITableLayoutModel {
        return {
            breakPoints: [
                {
                    gridAreas:
                        '"issuedDate energyLabelLetter functionalUnitNumber" "energyLabelID energyLabelID energyLabelID" "source source source" "method method method" "buildingID buildingID buildingID"',
                    gridColumns: "100px 75px 100px",
                    maxWidth: 420,
                },
                {
                    gridAreas:
                        '"issuedDate energyLabelLetter buildingID functionalUnitNumber" "energyLabelID energyLabelID energyLabelID energyLabelID" "source source source source" "method method method method"',
                    gridColumns: "100px 75px 90px 85px",
                    maxWidth: 725,
                },
                {
                    gridAreas:
                        '"issuedDate energyLabelLetter source method buildingID functionalUnitNumber" "energyLabelID energyLabelID energyLabelID energyLabelID energyLabelID energyLabelID"',
                    gridColumns: "100px 75px 150px 150px 90px 85px",
                    maxWidth: 1095,
                },
                {
                    gridAreas: '"issuedDate energyLabelLetter source method energyLabelID buildingID functionalUnitNumber"',
                    gridColumns: "100px 100px 150px 150px 1fr 100px 100px",
                },
            ],
        };
    }
}
